<template>
    <v-dialog v-model="show" max-width="70vw" scrollable>
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card :disabled="loading" :loading="loading">
            <v-card-title>Export invoices</v-card-title>
            <v-card-text>
              <v-simple-table v-if="formattedInvoices.length > 1">
                <tbody>
                <tr>
                  <th v-for="value in formattedInvoices[0]">{{value}}</th>
                </tr>
                <tr v-for="(items, index) in formattedInvoices">
                  <template v-if="index > 0" v-for="(item, itemIndex) in items">
                    <td v-if="itemIndex === 10" style="width:200px" :key="`${index}-${itemIndex}`">
                      <v-tooltip max-width="300" bottom>
                        <template v-slot:activator="{on}">
                          <span v-on="on">
                            {{item.length > 50 ? item.substring(0, 50) + '...' : item }}
                          </span>
                        </template>
                        <span>{{item}}</span>
                      </v-tooltip>
                    </td>
                    <td v-else :key="`${index}-${itemIndex}`">{{item.length > 50 ? item.substring(0, 50) + '...' : item }}</td>
                  </template>
                </tr>
                </tbody>
              </v-simple-table>
              <v-alert v-else type="info" dense>No invoices to export</v-alert>
<!--                <v-data-table-->
<!--                        :loading="loading"-->
<!--                >-->
<!--                </v-data-table>-->
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="exportInvoices">export</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save">Mark invoices as EXPORTED</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ExportInvoices",
        data: () => ({
            show: false,
            loading: false,
            invoices: [],
            contracts: [],
        }),
        watch:{
          show(v){
            if(v && !this.loading){
              this.loadInvoices()
            }
          }
        },
        mounted(){
            // this.loadInvoices();
        },
        computed:{
            formattedInvoices(){
                let invoices = [['Customer','Invoice Date','Due Date','Terms','Invoice','Service Date','Product/Service','Item Quantity','Item Rate','Item Amount', 'Description', 'Class']]
                const billingInvoices = this.$store.$db().model('billingInvoices').query().where((invoice) => !invoice.$isNew && !invoice.exported).orderBy('invoice_id', 'desc').get();
                billingInvoices.forEach(invoice => {
                    // let contract = this.contracts.find(contract => contract.customer_id === invoice.customer_id);
                    let contract = this.$store.$db().model('contracts').query().with('contract_type').where('customer_id', invoice.customer_id).first();
                    console.log(contract, "CONTRACT")
                    if(invoice.invoice_items){
                      let invoiceNotice = null;
                      let items = invoice.invoice_items.map(item => {
                        if(!invoiceNotice){
                          invoiceNotice = [
                            invoice.customer_name,
                            invoice.invoice_date,
                            (contract && contract.contract_type.desc === "NET 30" ? this.$moment(invoice.due_date).add(30, 'days').format("MM/DD/YYYY") : invoice.due_date ),
                            (contract && contract.contract_type.desc === "NET 30" ? "Net 30" : "Due on Receipt" ),
                            invoice.invoice_id,
                            invoice.invoice_date,
                            "QB Notice",
                            1,
                            0,
                            0,
                            "Note - we are not able to take payments via QuickBooks through the invoice link at this time. Credit card payments subject to 5% convenience fee. Returned payments are subject to an NSF fee of $40. A 1.5% late fee will be applied to any balance 30 days past due. Buyer is responsible for all expenses of collections, including reasonable attorney's fees.",
                            "Administrative"
                          ]
                        }
                        return [
                          invoice.customer_name,
                          invoice.invoice_date,
                          (contract && contract.contract_type.desc === "NET 30" ? this.$moment(invoice.due_date).add(30, 'days').format("MM/DD/YYYY") : invoice.due_date ),
                          (contract && contract.contract_type.desc === "NET 30" ? "Net 30" : "Due on Receipt" ),
                          invoice.invoice_id,
                          invoice.invoice_date,
                          item.package,
                          item.quantity ? item.quantity : 1,
                          item.customPrice,
                          item.quantity ? +item.customPrice * +item.quantity : item.customPrice,
                          item.description,
                          item.is_rnd ? "Non-mandatory" : "Compliance"
                        ]
                      })
                      invoices.push(...items)
                      invoices.push(invoiceNotice)
                    }
                })
                return invoices;
            }
        },
        methods:{
            async loadInvoices(){
                this.loading =true;
                await this.$store.$db().model('billingInvoices').load({deleteAll: false, where: ['exported', '==', false]})
                // extract unique customer_id from billingInvoices
                const billingInvoices = this.$store.$db().model('billingInvoices').query().where((invoice) => !invoice.$isNew && !invoice.exported).orderBy('invoice_id', 'desc').get();
                let customer_ids = billingInvoices.map(invoice => invoice.customer_id);
                // filter duplicate ids
                customer_ids = customer_ids.filter((id, index) => customer_ids.indexOf(id) === index);
                await this.$store.$db().model('contracts').api().fetch({
                  where_in: {key: 'customer_id', values: customer_ids},
                  with: 'contractType'
                });
                // await this.$store.$db().model('billingInvoices').load({deleteAll: false, where: ['exported', '==', true], limit:20})
                await this.loadContracts();
                this.loading = false
            },
            async loadContracts(){
              // const billingInvoices = this.$store.$db().model('billingInvoices').query().where((invoice) => !invoice.$isNew && !invoice.exported).orderBy('invoice_id', 'desc').get();
              // const billingInvoices = this.$store.$db().model('billingInvoices').query().orderBy('invoice_id', 'desc').get();
              // this.contracts = this.$store.$db().model("customers").query().where((cust) => billingInvoices.some(invoice => invoice.customer_id === cust.id)).get().map(cust => cust.contract).filter(contract => contract);
            },
            exportInvoices(){
                let csvContent = ""
                    + this.formattedInvoices.map(e => e.map(value => {
                      if(typeof value === "string" && value.includes(',')){
                        return `"${value}"`
                      }
                      return value
                    }).join(",")).join("\n");
                let blob = new Blob([csvContent], {type: 'text/csv'});
                // let encodedUri = encodeURI(csvContent);
                let encodedUri = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "INVOICE_EXPORT.csv");
                document.body.appendChild(link); // Required for FF

                link.click();
            },
            async save(){
              this.loading = true;
                let stored = await this.$store.$db().model('billingInvoices').update({
                  where: (invoice) => !invoice.$isNew && !invoice.exported,
                  data: {exported: true},
                })
                await this.$store.$db().model('billingInvoices').updateBatchStore(stored)
                this.$store.dispatch("showSuccess", "Invoices marked as 'EXPORTED'")
              this.loading = false;
                this.loadInvoices().catch(() => this.loading = false)
            }
        }
    }
</script>

<style scoped>

</style>
